export default "__VITE_ASSET__c1b2ffa3__"